import { ca } from '@cian/analytics';

export interface IPageExtra {
  review_id?: string;
  question_id?: string;
  type: string;
  rating: number | null;
}

export interface IPage {
  dealType?: string | null;
  objectType?: string | null;
  offerID?: number;
  offerPhone?: string;
  pageType?: string;
  siteType?: string;
  extra: IPageExtra;
}

export function trackNewAnswerSubmit(page: IPage) {
  ca('eventSite', {
    action: 'Success',
    category: 'NewbuildingReviews',
    label: 'Reply',
    name: 'oldevent',
    useLastProducts: true,
    page: page as unknown as Record<string, unknown>,
  });
}
